// extracted by mini-css-extract-plugin
export default {"DivContainer":"WingsCard_DivContainer__peEnJ","InlineDiv":"WingsCard_InlineDiv__FrYBC","Title":"WingsCard_Title__u2LEl"};